import { render, staticRenderFns } from "./allocate-past-promotions.vue?vue&type=template&id=f997091c&scoped=true"
import script from "./allocate-past-promotions.vue?vue&type=script&lang=js"
export * from "./allocate-past-promotions.vue?vue&type=script&lang=js"
import style0 from "./allocate-past-promotions.vue?vue&type=style&index=0&id=f997091c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f997091c",
  null
  
)

export default component.exports